
import { createTheme } from '@mui/material/styles';
export const darkBg = 'rgb(18, 19, 24)';
export const darkTxt = 'rgb(227, 225, 233)';
export const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: 'rgb(185, 195, 255)',
        contrastText: 'rgb(32, 44, 97)',
      },
      secondary: {
        main: 'rgb(195, 197, 221)',
        contrastText: 'rgb(44, 47, 66)',
      },
      tertiary: {
        main: 'rgb(229, 186, 217)',
        contrastText: 'rgb(68, 38, 62)',
      },
      error: {
        main: 'rgb(255, 180, 171)',
        contrastText: 'rgb(105, 0, 5)',
      },
      background: {
        default: 'rgb(18, 19, 24)',
        paper: 'rgb(18, 19, 24)',
      },
      surface: {
        main: 'rgb(18, 19, 24)',
        variant: 'rgb(69, 70, 79)',
        dim: 'rgb(18, 19, 24)',
        bright: 'rgb(56, 57, 63)',
        container: 'rgb(31, 31, 37)',
        containerLow: 'rgb(27, 27, 33)',
        containerHigh: 'rgb(41, 42, 47)',
      },
      text: {
        primary: 'rgb(227, 225, 233)',
        secondary: 'rgb(198, 197, 208)',
        disabled: 'rgb(144, 144, 154)',
        hint: 'rgb(69, 70, 79)',
      },
    },
    typography: {
      fontFamily: 'Comfortaa, sans-serif',
    },
  });
  
export const lightBg = 'rgb(251, 248, 255)';
export const lightTxt = 'rgb(27, 27, 33)';
 export  const lightTheme = createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: 'rgb(80, 91, 146)',
        contrastText: 'rgb(255, 255, 255)',
      },
      secondary: {
        main: 'rgb(90, 93, 114)',
        contrastText: 'rgb(255, 255, 255)',
      },
      tertiary: {
        main: 'rgb(118, 84, 110)',
        contrastText: 'rgb(255, 255, 255)',
      },
      error: {
        main: 'rgb(186, 26, 26)',
        contrastText: 'rgb(255, 255, 255)',
      },
      background: {
        default: 'rgb(251, 248, 255)',
        paper: 'rgb(251, 248, 255)',
      },
      surface: {
        main: 'rgb(251, 248, 255)',
        variant: 'rgb(226, 225, 236)',
        dim: 'rgb(219, 217, 224)',
        bright: 'rgb(251, 248, 255)',
        container: 'rgb(239, 237, 244)',
        containerLow: 'rgb(245, 242, 250)',
        containerHigh: 'rgb(233, 231, 239)',
      },
      text: {
        primary: 'rgb(27, 27, 33)',
        secondary: 'rgb(69, 70, 79)',
        disabled: 'rgb(118, 118, 128)',
        hint: 'rgb(118, 118, 128)',
      },
    },
    typography: {
      fontFamily: 'Comfortaa, sans-serif',
    },
  });
  